import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <a href="/">
            <div aria-label="Schedler Serve Home" className="navigation-logo">
              <div className="navigation-logo-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 3v18m7-13l3 8a5 5 0 0 1-6 0zV7"></path>
                    <path d="M3 7h1a17 17 0 0 0 8-2a17 17 0 0 0 8 2h1M5 8l3 8a5 5 0 0 1-6 0zV7m2 14h10"></path>
                  </g>
                </svg>
              </div>
              <span className="section-subtitle">
                KS Process Service, Inc.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
          </a>
          <button
            id="mobile-menu-toggle"
            aria-label="Open Menu"
            aria-expanded="false"
            className="navigation-mobile-toggle"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M4 6h16M4 12h16M4 18h16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="mobile-navigation-overlay" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <a href="/">
            <div aria-label="Schedler Serve Home" className="navigation-logo">
              <div className="navigation-logo-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 3v18m7-13l3 8a5 5 0 0 1-6 0zV7"></path>
                    <path d="M3 7h1a17 17 0 0 0 8-2a17 17 0 0 0 8 2h1M5 8l3 8a5 5 0 0 1-6 0zV7m2 14h10"></path>
                  </g>
                </svg>
              </div>
              <span className="section-subtitle">Schedler Serve</span>
            </div>
          </a>
          <button
            id="mobile-menu-close"
            aria-label="Close Menu"
            className="navigation-mobile-close"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-5.5-3.5l-5 5m0-5l5 5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <div className="navigation-overlay-links">
            <a href="/">
              <div className="navigation-overlay-link">
                <span>Services</span>
              </div>
            </a>
            <a href="/">
              <div className="navigation-overlay-link">
                <span>Coverage Area</span>
              </div>
            </a>
            <a href="/">
              <div className="navigation-overlay-link">
                <span>About Us</span>
              </div>
            </a>
            <a href="/">
              <div className="navigation-overlay-link">
                <span>Texas Process Servers</span>
              </div>
            </a>
          </div>
          <div className="navigation-overlay-footer">
            <a href="/">
              <div className="btn btn-lg btn-primary">
                <span>Get a Free Quote</span>
              </div>
            </a>
            <p className="section-content">
              Dallas–Fort Worth &amp; Statewide Texas
            </p>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-mobile-overlay {
  transition: none;
}
.navigation-link::after {
  transition: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const menuToggle = document.getElementById("mobile-menu-toggle")
  const menuClose = document.getElementById("mobile-menu-close")
  const mobileOverlay = document.getElementById("mobile-navigation-overlay")
  const bodyElement = document.body

  function openMenu() {
    mobileOverlay.style.display = "flex"
    // Small delay to allow display: flex to register for transition
    setTimeout(() => {
      mobileOverlay.classList.add("is-open")
      menuToggle.setAttribute("aria-expanded", "true")
      bodyElement.style.overflow = "hidden"
    }, 10)
  }

  function closeMenu() {
    mobileOverlay.classList.remove("is-open")
    menuToggle.setAttribute("aria-expanded", "false")
    bodyElement.style.overflow = ""

    // Wait for transition to finish before hiding
    setTimeout(() => {
      if (!mobileOverlay.classList.contains("is-open")) {
        mobileOverlay.style.display = "none"
      }
    }, 300)
  }

  menuToggle.addEventListener("click", openMenu)
  menuClose.addEventListener("click", closeMenu)

  // Close menu when clicking on a link
  const mobileLinks = mobileOverlay.querySelectorAll(".navigation-overlay-link")
  mobileLinks.forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  // Handle ESC key to close menu
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileOverlay.classList.contains("is-open")) {
      closeMenu()
    }
  })

  // Close menu if window is resized above mobile breakpoint
  window.addEventListener("resize", () => {
    if (window.innerWidth > 767 && mobileOverlay.classList.contains("is-open")) {
      closeMenu()
    }
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
